<template>
  <div class="container">
    <div class="container-content">
      <div class="content-title">课程分类</div>
      <div class="query">
        <MyForm class="search-form" :formOptions="queryForm" :inline="true"></MyForm>
      </div>
      <div class="table">
        <MyTable :table-options="tableOptions" border max-height="65vh">
          <template #handler="{ row }">
            <el-button
              style="color: #6fcaf7"
              icon="Edit"
              link
              @click="click_edit(row)"
              >编辑</el-button>
          </template>
        </MyTable>
        <MyPagination :params="paginationParams" :total="total" @get-list="getList" ref="paginationRef" />
      </div>
    </div>
    <!-- 新增分类 -->
    <Dialog
      v-model="addVisible"
      :title="title"
      top="5vh"
      @closed="handleClosed"
      width="30%"
    >
      <el-form class="add-user-form" ref="formRef" :model="formData">
        <el-form-item label="分类名称:" prop="name" :rules="[{ required: true, message: '请输入分类名称', trigger: 'blur' }]">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
      </el-form>
      <div class="submit-buttons">
        <el-button plain @click="addVisible = false">取消</el-button>
        <MyButton @click="click_confirm">确定</MyButton>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import MyTable from "@/components/Global/MyTable.vue";
import MyButton from "@/components/Global/MyButton.vue";
import MyPagination from "@/components/Global/MyPagination.vue";
import { ref, reactive } from "vue";
import dictionary from "@/api/dict.js";
import { dayjs } from "element-plus";

const title = ref("新增");
// 搜索
const queryForm = reactive({
  itemList: [
    {
      type: "Input",
      label: "课程分类：",
      prop: "Name",
      attrs: {
        placeholder: "请输入关键词",
      },
    },
    {
      type: "Button",
      value: "查询",
      attrs: {
        icon: "Search",
      },
      events: {
        click(formData) {
          Object.assign(paginationParams, formData);
        },
      },
    },
    {
      type: "Button",
      value: "新增",
      attrs: {
        icon: "Plus",
      },
      events: {
        click(formData) {
          addVisible.value = true;
          title.value = "新增";
        },
      },
    },
  ],
});

// 表格
const tableOptions = reactive({
  colList: [
    { type: "index", label: "序号", width: 60 },
    { label: "分类名称", prop: "name" },
    { label: "创建时间", prop: "creationTime" },
    { type: "slot", slot_name: "handler", label: "操作" },
  ],
  tableData: [],
});

// 新增心理测评
const addVisible = ref(false);
const formData = ref({
  code: "course",
  name: "",
});

// 新增心理测评 确认按钮
const formRef = ref();
const click_confirm = () => {
  formRef.value.validate(async (v) => {
    if (!v) return;
    try {
      formData.value.id ? await dictionary.put(formData.value.id, formData.value) 
      : await dictionary.add(formData.value)
      addVisible.value=false
      ElMessage.success(`${formData.id?"修改":"添加"}成功`);
      getList();
    } catch (error) {
      console.error("添加失败", error);
    }
  })
};
// 弹框关闭回调
const handleClosed = () => {
  clearForm();
};
// 清空表单值
const clearForm = () => {
  formData.value = {
    code: "course",
    name: "",
  };
};

// 编辑
const click_edit = (row) => {
  formData.value = { ...row };
  addVisible.value = true;
  title.value = "编辑";
};

const paginationParams = reactive({
  Code: "course",
  Sorting: "code",
})
const paginationRef = ref();
const total = ref(0);
const getList = (params = paginationRef.value.getList_params) => {
  dictionary.getList(params).then(res=>{
    const { items, totalCount } = res.data;
    total.value = totalCount;
    tableOptions.tableData = items.map(item => {
      item.creationTime = dayjs(item.creationTime).format("YYYY-MM-DD HH:mm:ss");
      return item;
    });
  });
};
</script>

<style lang="scss" scoped>
.add-user-form {
  padding: 20px 40px;
}
</style>
